<template>
    <v-list-item two-line>
        <v-list-item-content>
            <v-list-item-subtitle>{{ reply.field.title }}</v-list-item-subtitle>
            <v-list-item-title>
                {{ reply.field_payment_method.name }}
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    export default {
        name: "FieldPaymentMethodReply",
        props: {
            reply: {type: Object, default: () => {}}
        },
    }
</script>

<style scoped>

</style>